<script setup lang="ts">
import type { ElRadioButton } from 'element-plus';

type ModelValueType = InstanceType<typeof ElRadioButton>['$props']['modelValue'];

interface Props {
  value?: ModelValueType,
  text?: string,
  disabled?: boolean,
}
export interface  Emits {
  change: [value: ModelValueType]
};

const props = withDefaults(defineProps<Props>(), {
  text: '',
  disabled: false,
});
const emit = defineEmits<Emits>();

const modelValue = defineModel<ModelValueType>();

function handleChange(value: ModelValueType) {
  emit('change', value);
}
</script>

<template>
  <div class="ui-radio">
    <ElRadio
      v-model="modelValue"
      class="ui-radio__element"
      :value="value"
      :disabled="disabled"
      @change="handleChange"
    >
      <slot>
        <span v-html="text" />
      </slot>
    </ElRadio>
  </div>
</template>

<style lang="scss">
.ui-radio{
  line-height: normal;
  &__element {
    display: flex;
    align-items: flex-start;
  }
  &__element.el-radio {
    --el-radio-text-color: var(--text-body);
    --el-radio-input-border-color: var(--border-default);
    --el-radio-input-border-color-hover: var(--background-primary);
    --el-color-primary: var(--background-primary);
    --el-radio-font-size: 13px;
    --el-radio-font-weight: 400;
    --el-radio-input-height: 16px;
    --el-radio-input-width: 16px;
    //height: var(--el-radio-input-height);
    height: auto;
  }
  .el-radio__inner{
    &:after{
      width: 6px;
      height: 6px;
    }
  }
  .el-radio__label{
    padding-left: 4px;
    white-space: break-spaces;
  }
  .el-radio__input.is-checked+.el-radio__label {
    color: var(--text-body);
  }
}
</style>
